var template = require('employer/templates/payrollHistory/PickupDateModal.ejs');
var ModalForm = require('commons/views/ModalForm');
var loader    = require('helpers/loader');
var moment    = require('moment');

module.exports = ModalForm.extend({

    events: {
        'click .js-cancel': 'cancel',
        'click .js-save':   'save',
    },

    setModel: function(model) {
        var self = this;
        self.model = model;
    },

    render: function() {
        var self = this;
        self.$el.html(template());
        self.$pickDate = self.$('.js-pickup-date');
        self.$pickDate.datepicker({
            startDate: moment.tz('Asia/Kuala_Lumpur')
                             .add(24 + 11, 'hours')
                             .toDate(),
            weekStart: 1,
            daysOfWeekDisabled: [0, 6],
            autoclose: true,
            todayHighlight: true
        });
        return self;
    },

    save: function() {
        var self = this;
        self.model.set({
            chequePickupDate: self.$pickDate.datepicker('getDate')
        });
        if (self.model.isValid()) {
            var stopLoader = loader.startFullScreen(self.$('.js-save'));
            self.model.save().then(function() {
                self.trigger('save', self.model);
                self.hide();
                stopLoader();
            });
        }
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payrollHistory/PickupDateModal.js